import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useHomeContext } from "../../provider/HomeProvider";
import SharedSafariSkeletonCard from "../common/Skeleton/SharedSafariSkeletonCard";
import SharedsafariCard from "components/SharedSafari/SharedsafariCard";
// import SharedsafariCard from "./SharedsafariCard";

const SharedSafariSection = () => {
  const { loading, shareSafaris } = useHomeContext();
  return (
    <section className="sharesafri">
      <Container fluid="lg" className="padditg_mobile">
        <Row className="justify-content-center">
          <Col xl={11} className="px-md-1 px-0">
            <div className="sharesafribg home px-lg-0 px-2">
              <div className="safarishareBox py-xxl-3 pb-xxl-5">
                <Row className="justify-content-center">
                  <Col xxl={3}></Col>
                  <Col xxl={9} lg={12} xl={12}>
                    <div className="title_safari JoinPadding phone_padding d-flex justify-content-center justify-content-md-between align-items-center flex-wrap">
                      <h4 className="text-center ps-lg-4">
                        Discover and Join 100+ Shared Safaris
                      </h4>
                      <div className="joinshareView mt-md-0 mt-3 px-md-4 d-sm-block d-none">
                        <Link to="/sharesafari" className="btn_shareView">
                          View All
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="postion_setsfari px-md-4 ps-xxl-5 padding_mobileAdded row gx-4">
                  <Col lg={12} sm={12} xxl={3} md={12} className="mb-4 "></Col>

                  {Array.isArray(shareSafaris) && shareSafaris?.length > 0 ? (
                    shareSafaris.slice(0, 3).map((safari) => (
                      <Col
                        lg={4}
                        sm={6}
                        xxl={3}
                        md={6}
                        className="mb-4 homepagecards"
                        key={safari.id}
                      >
                        <SharedsafariCard safari={safari} page='home'/>
                      </Col>
                    ))
                  ) : loading ? (
                    <>
                      {[1, 2, 3].map((_, index) => (
                        <Col
                          lg={4}
                          sm={6}
                          xxl={3}
                          md={6}
                          className="mb-4 homepagecards"
                          key={`skeleton-${index}`}
                        >
                          <SharedSafariSkeletonCard />
                        </Col>
                      ))}
                    </>
                  ) : (
                    <p>No safaris available</p>
                  )}

                  <Col
                    xxl={3}
                    className="joinshareView pb-sm-0 pb-4 px-5 text-center pe-lg-4 d-sm-none d-block"
                  >
                    <Link
                      to="/sharesafari"
                      className="btn_shareView w-100 d-block"
                    >
                      View All
                    </Link>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SharedSafariSection;
